import Router from './route/Router';

function App() {
  return (
    <Router/>
  );
}

export default App;